export enum PaymentMethod {
    Paypal = 'paypal',
    Visa = 'visa',
    Mastercard = 'mastercard',
    Amex = 'amex',
    AmazonPay = 'amazonPay',
    Invoice = 'invoice',
    Klarna = 'stripeKlarna',
    GooglePay = 'stripeGooglePay',
    ApplePay = 'stripeApplePay',
}
